/* eslint-disable */
export const whatsappPhones = [
    {
        _id: '1',
        userId: 'user1',
        phoneNumberId: '123456789',
        businessName: 'Mi Negocio',
        createdAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 días
        isActive: true,
        metadata: {
            displayPhoneNumber: '+1234567890',
            phoneNumberStatus: 'VERIFIED',
            businessProfileStatus: 'ACTIVE',
            webhook: '',
            apiKey: ''
        },
        wabaId: 'waba_123'
    }
];
